const COLLECTIONS = {
  SPECS: 'Specs',
  STORE_PRODUCTS: 'Stores/Products',
  TASKS: 'Tasks',
  COMPILED_PRODUCTS: 'CompiledProducts',
  CMS_PRODUCTS: 'Products1',
  CMS_PRODUCTS_KEY_FEATURES: 'ProductsKeyFeatures',
  DEBUG_PRODUCTSFEEDBACK: 'debugProductsFeebdack',
};

const COLLECTIONS_FIELDS = {
  TASKS: [
    { key: 'name', type: 'TEXT' },
    { key: 'data', type: 'OBJECT' },
    { key: 'type', type: 'TEXT', enum: ['event', 'scheduled'] },
    {
      key: 'status',
      type: 'TEXT',
      enum: ['pending', 'in_progress', 'success', 'skipped', 'failed'],
    },
    { key: 'error', type: 'TEXT' },
    { key: 'amountOfRetries', type: 'NUMBER' },
    {
      key: 'parentTaskId',
      type: 'REFERENCE',
      typeMetadata: { reference: { referencedCollectionId: 'Tasks' } },
    },
    { key: 'Task Result', type: 'TEXT' },
  ],
};

module.exports = {
  COLLECTIONS,
  COLLECTIONS_FIELDS,
};
